import { Box } from '@chakra-ui/react';
import { Table as ReactTable } from '@tanstack/react-table';
import _ from 'lodash';
import React from 'react';

import { utils as commonUtils } from '@finley-technologies/common';

import { IsolatedMultiSelect } from 'packages/common-frontend/components/MultiSelect';

export const createColumnVisibility = ({
  columnDefs,
  selectedOptions,
}: {
  columnDefs: string[];
  selectedOptions: string[];
}) => {
  const columnVisibility: { [key: string]: boolean } = {};
  _.forEach(columnDefs, (key) => {
    if (selectedOptions.includes(key)) {
      columnVisibility[key] = true;
    } else {
      columnVisibility[key] = false;
    }
  });

  return columnVisibility;
};

type ColumnSelectorProps = { tableInstance: ReactTable<any> };
export const ColumnSelector = ({ tableInstance }: ColumnSelectorProps) => {
  const onApplyOptions = (selectedOptions: string[]) => {
    const newColumnVisibility = createColumnVisibility({
      columnDefs: _.map(tableInstance.getAllLeafColumns(), 'id'),
      selectedOptions,
    });

    tableInstance.setColumnVisibility(newColumnVisibility);
  };

  const options = _.compact(
    _.map(tableInstance.getAllLeafColumns(), (column) => {
      // in the case where the column header (headerKey) and id (accessorKey) differ
      const header = column.columnDef.header ?? column.id;
      return {
        label: commonUtils.toSentenceCase(
          typeof header === 'string' ? header : column.id,
        ),
        value: column.id,
      };
    }),
  );

  const initialSelections = _.compact(
    _.map(tableInstance.getAllLeafColumns(), (column) => {
      return column.getIsVisible() ? column.id : null;
    }),
  );

  return (
    <Box w="228px" h="44px">
      <IsolatedMultiSelect
        options={options}
        initialSelections={initialSelections}
        onApplyOptions={onApplyOptions}
        optionsHeader="Property"
        titleText="Show/Hide Columns"
        applyButtonText="Display selected columns"
        colorScheme="aurora"
        borderWidth="medium"
      />
    </Box>
  );
};
